/**
 * Copyright Mántum All Rights Reserved.
 */
import Button from '../../button';
import Body from './body';

import type { Context, Option, Options } from '../type';

type PropTypes = {
    description?: string;
    label: string;
    onClick?: (value: Context | Option) => void;
    options?: Options;
    testid?: string;
    value: Context;
};

export default function Module(props: PropTypes) {
    const onClick = () => {
        if (props.onClick) {
            props.onClick(props.value);
        }
    };

    return (
        <Body onClick={onClick} options={props.options}>
            <Button
                className='group w-full p-4 text-left'
                onClick={onClick}
                testid={props.testid}
                title={`${props.label}\n${props.description ?? ''}`}
            >
                <label className='line-clamp-1 w-4/5 cursor-pointer text-ellipsis break-all text-lg font-medium group-hover:text-primary'>
                    {props.label}
                </label>
                {props.description && (
                    <p className='line-clamp-3 overflow-hidden text-ellipsis'>
                        {props.description}
                    </p>
                )}
            </Button>
        </Body>
    );
}
